<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
  mounted() {
    if (typeof document === "undefined") {
      return;
    }

    document.documentElement.setAttribute("data-coreui-theme", "dark");
    document.body.setAttribute("data-coreui-theme", "dark");
  }
};
</script>

<style>
/* CoreUI Icons Pro Set */
@import "~@coreui/icons-pro/css/all.min.css";
/* Import Font Awesome Icons Set */
@import "~font-awesome/css/font-awesome.min.css";
/* Import Simple Line Icons Set */
@import "~simple-line-icons/css/simple-line-icons.css";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
</style>

<style lang="scss">
/* Import Main styles for this application */
@use "assets/scss/style.scss";

html,
body,
#app {
  min-height: 100%;
}

html,
body {
  background: var(--cui-body-bg);
  color: var(--cui-body-color);
}

body a:not(.btn):not(.nav-link):not(.dropdown-item):not(.page-link):not(.sidebar-brand) {
  color: #0d6efd;
}

body a:not(.btn):not(.nav-link):not(.dropdown-item):not(.page-link):not(.sidebar-brand):hover,
body a:not(.btn):not(.nav-link):not(.dropdown-item):not(.page-link):not(.sidebar-brand):focus {
  color: #6ea8fe;
}

body .btn-link,
body [role="button"].btn-link,
body a.btn-link,
body button.btn-link,
body span.btn-link {
  color: #0d6efd !important;
  text-decoration: underline;
}

body .btn-link:hover,
body .btn-link:focus,
body [role="button"].btn-link:hover,
body [role="button"].btn-link:focus,
body a.btn-link:hover,
body a.btn-link:focus,
body button.btn-link:hover,
body button.btn-link:focus,
body span.btn-link:hover,
body span.btn-link:focus {
  color: #6ea8fe !important;
}
</style>
